<template>
    <div class="saas-page linear-log-page">
        <div class="saas-hero card-saas linear-page-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{trans('activity.activity_log')}}</span>
                </p>
                <span class="linear-eyebrow">{{trans('activity.activity_log')}}</span>
                <h1 class="saas-hero__title">{{trans('activity.activity_log')}}</h1>
            </div>
            <div class="linear-command-actions">
                <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" @click.prevent="showFilterPanel = !showFilterPanel">
                    <admin-icon name="sliders"></admin-icon> <span>{{trans('general.filter')}}</span>
                </button>
            </div>
        </div>
        <transition name="fade">
            <div class="card-saas linear-filter-card" v-if="showFilterPanel">
                <div class="linear-section-head">
                    <div>
                        <span>{{trans('activity.activity_log')}}</span>
                        <h4>{{trans('general.filter')}}</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group" v-show="users">
                            <label for="">{{trans('user.user')}}</label>
                            <select v-model="filterActivityLogForm.user_id" class="custom-select col-12">
                              <option value="">{{trans('general.select_one')}}</option>
                              <option v-for="user in users" v-bind:value="user.id" :key="user.id">
                                {{ user.profile.first_name+' '+user.profile.last_name }}
                              </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <date-range-picker :start-date.sync="filterActivityLogForm.created_at_start_date" :end-date.sync="filterActivityLogForm.created_at_end_date"></date-range-picker>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="admin-list-table-card linear-table-card mt-3" v-if="activity_logs.total">
            <div class="linear-section-head linear-section-head--table">
                <div>
                    <span>{{trans('activity.activity_log')}}</span>
                    <h4>{{trans('activity.activity')}}</h4>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table admin-data-table linear-dense-table mb-0">
                    <thead>
                        <tr>
                            <th>{{trans('activity.user')}}</th>
                            <th>{{trans('activity.ip')}}</th>
                            <th>{{trans('activity.user_agent')}}</th>
                            <th>{{trans('activity.activity')}}</th>
                            <sortable-th field="created_at" :sort-by="filterActivityLogForm.sort_by" :order="filterActivityLogForm.order" @sort="sortList">{{trans('activity.date_time')}}</sortable-th>
                            <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="activity_log in activity_logs.data" :key="activity_log.id">
                            <td>
                                <span class="linear-table-primary" v-text="activity_log.user.profile.first_name+' '+activity_log.user.profile.last_name"></span>
                            </td>
                            <td><span class="linear-mono" v-text="activity_log.ip"></span></td>
                            <td>
                                <span class="linear-table-muted linear-table-truncate" v-text="activity_log.user_agent"></span>
                            </td>
                            <td>
                                <span class="linear-table-primary">{{trans('activity.'+activity_log.activity,{activity: trans('activity.'+activity_log.module)})}}</span>
                            </td>
                            <td><span class="linear-table-muted">{{activity_log.created_at | moment }}</span></td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item-button
                                        v-confirm="{ok: confirmDelete(activity_log)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> {{ trans('general.delete') }}
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="admin-table-pagination-wrap">
                <pagination-record :page-length.sync="filterActivityLogForm.page_length" :records="activity_logs" @updateRecords="getActivityLogs"></pagination-record>
            </div>
        </div>
        <div class="admin-list-table-card admin-empty-state linear-empty-state mt-3" v-if="!activity_logs.total" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="list"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('general.no_result_found') }}</h4>
                <p class="admin-empty-state__text">{{trans('activity.activity_log')}}</p>
            </div>
        </div>
    </div>
</template>
<script>
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components: {dateRangePicker},
        data(){
            return {
                activity_logs: {
                    total: 0,
                    data: []
                },
                filterActivityLogForm: {
                    page_length: helper.getConfig('page_length'),
                    user_id: '',
                    created_at_start_date: '',
                    created_at_end_date: '',
                    sort_by: 'created_at',
                    order: 'desc'
                },
                users: [],
                showFilterPanel: false
            };
        },
        mounted(){
            if(!helper.featureAvailable('activity_log')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            this.getActivityLogs();
        },
        methods: {
            getActivityLogs(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterActivityLogForm);
                axios.get('/api/activity-log?page=' + page + url)
                    .then(response => response.data)
                    .then(response => {
                        this.users = response.users;
                        this.activity_logs = response.activity_logs;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            confirmDelete(activity_log){
                return dialog => this.deleteActivityLog(activity_log);
            },
            deleteActivityLog(activity_log){
                axios.delete('/api/activity-log/'+activity_log.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getActivityLogs();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            sortList(field){
                if (this.filterActivityLogForm.sort_by === field) {
                    this.filterActivityLogForm.order = this.filterActivityLogForm.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.filterActivityLogForm.sort_by = field;
                    this.filterActivityLogForm.order = 'asc';
                }
            }
        },
        filters: {
          moment(date) {
            return helper.formatDateTime(date);
          }
        },
        watch: {
            filterActivityLogForm: {
                handler(val){
                    this.getActivityLogs();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
.linear-page-hero {
    align-items: center;
}

.linear-eyebrow,
.linear-section-head span {
    color: #635bff;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-command-actions {
    display: flex;
    justify-content: flex-end;
}

.linear-filter-card {
    padding: 1rem 1.15rem;
}

.linear-section-head {
    margin-bottom: 1rem;
}

.linear-section-head h4 {
    margin: 0.25rem 0 0;
    color: #0f172a;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: -0.03em;
}

.linear-section-head--table {
    margin: 0;
    padding: 0.95rem 1.125rem;
    border-bottom: 1px solid #e2e8f0;
}

.linear-table-card,
.linear-empty-state {
    overflow: hidden;
    border-radius: 14px;
}

.linear-dense-table tbody td {
    vertical-align: middle;
}

.linear-table-primary {
    color: #0f172a;
    font-weight: 800;
}

.linear-table-muted {
    color: #64748b;
}

.linear-mono {
    color: #475569;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
    font-size: 0.8125rem;
}

.linear-table-truncate {
    display: block;
    max-width: 24rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

@media (max-width: 575.98px) {
    .linear-page-hero {
        align-items: flex-start;
    }

    .linear-command-actions {
        justify-content: flex-start;
        width: 100%;
    }
}
</style>
